import React from "react";

const SkillSet2 = () => {
    return(
        <div className="skills__content">
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">C/C++</h3>
                        <span className="skills__level">&#9679; &#9679; &#9679; &#9679; &#9675;</span>
                    </div>
                </div>
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">Data Structures</h3>
                        <span className="skills__level">&#9679; &#9679; &#9679; &#9679; &#9675;</span>
                    </div>
                </div>
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">SQL</h3>
                        <span className="skills__level">&#9679; &#9679; &#9679; &#9679; &#9675;</span>
                    </div>
                </div>
            </div>
            <div className="skills__group">
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">Python</h3>
                        <span className="skills__level">&#9679; &#9679; &#9679; &#9679; &#9675;</span>
                    </div>
                </div>
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">OOPs</h3>
                        <span className="skills__level">&#9679; &#9679; &#9679; &#9679; &#9675;</span>
                    </div>
                </div>
                <div className="skills__data">
                    <div>
                        <h3 className="skills__name">OpenCV</h3>
                        <span className="skills__level">&#9679; &#9679; &#9679; &#9675; &#9675;</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default SkillSet2;